define(
    'views/process-options',[
        'jquery',

        'connections/process-connection',

        'utils/toast',
        'utils/is-extension',
        'utils/pikaday-i18n',

        'pikaday',
    ],

    function ($, ProcessConnection, Toast, isExtension, pikadayi18n, Pikaday) {
        var _this;
        return (function () {
            function ProcessOptions() {
                this.processOptions = [];
                _this = this;
            }

            ProcessOptions.prototype.init = function (container) {
                this.container = container;

                this.initBindings();
                this.initDeliveryDate();

                this.getProcessOptionsPartialView();
            };

            ProcessOptions.prototype.initBindings = function () {
                // TODO: Replace with correct classes
                this.container.on('submit', '.process-option__form', this.updateProcessOptions);
                this.container.on('submit', '.process-general__form', this.updateGeneralParameters);
                this.container.on('click', '.remove', this.removeProcessOption);
                this.container.on('click', '#processTypesAddButton', this.addProcessOption);
                this.container.on('change', '.inputfile', this.uploadResource);
                this.container.on('click', '.cart-process__delivery-date', this.toggleDatepicker);
                this.container.on('blur', '.error', this.removeErrorStyles);
                this.container.on('blur', 'input[name="repeat"]', this.removeFileErrorStyles);
                this.container.on('change', 'input:not([type=file]), textarea, select, button', this.showSaveBtn);
                this.container.on('blur', '.width, .height', function () {
                    _this.areaValid($(this).closest('.sizeInput'));
                });
            };

            ProcessOptions.prototype.removeErrorStyles = function () {
                $('#placeOrderButton').removeClass('button--error');
                $(this).removeClass('error');
            };

            ProcessOptions.prototype.removeFileErrorStyles = function () {
                if ($(this).val() !== '') $('.process-option__form .inputfile').parent().removeClass('error');
            };

            ProcessOptions.prototype.addProcessOption = function () {
                var type = $('#processTypes').val();
                var $button = $(this);

                $button.prop('disabled', true).append('<div class="loader button-loader"></div>');
                ProcessConnection.addProcessOption(type)
                    .then(function (res) {
                        _this.getProcessOptionsPartialView();
                    })
                    .always(function () {
                        $button.prop('disabled', false).find('.loader').remove();
                    });
            };

            ProcessOptions.prototype.uploadResource = function (e) {
                e.preventDefault();

                var $input = $(e.target);
                var $button = $input.parent();
                var $fileName = $button.siblings('.filename');
                var $loader = $button.siblings('.loader');
                var file = e.target.files[0];
                var maxSize = $input.data('maxsize');
                var formats = $input.data('formats');

                // Prevalidate user mistakes.
                if (!file) return;

                if (file.size > maxSize || !isExtension(file.name, formats)) {
                    $button.addClass('error');
                    Toast.queueError('File error. Maxsize: ' + (maxSize / 1024 / 1024) + 'MB. Allowed file formats: ' + formats.join(', '), 6000);
                    return;
                } else {
                    $button.removeClass('error');
                }

                var fr = new FileReader();
                fr.onload = (function (frEvent) {
                    $input.prop('disabled', 'disabled');
                    $button.css('background', 'lightgray');
                    $loader.show();
                    $fileName.hide();

                    var fileData = {
                        name: file.name,
                        size: file.size,
                        type: file.type,
                    };
                    var id = $input.closest('.cart-process').data('process-id');

                    ProcessConnection.uploadDesign(id, frEvent.target.result, fileData).success(function (res) {
                        $fileName.text(file.name).show();
                    }).always(function () {
                        $input.removeAttr('disabled');
                        $button.css('background', '');
                        $loader.hide();
                    });
                });

                fr.readAsDataURL(file);
            };

            ProcessOptions.prototype.updateProcessOptions = function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $unsavedForms = $('.submit--visible').closest('.process-option__form');
                var deferreds = [];

                $.each($unsavedForms, function (i, form) {
                    deferreds.push(_this.updateProcessOption($(form)));
                });

                $.when.apply($, deferreds).then(function () {
                    _this.getProcessOptionsPartialView();
                });
            };

            ProcessOptions.prototype.updateProcessOption = function ($form) {
                var $loader = $form.find('.process-loader');
                var id = $form.closest('.cart-process').data('process-id');
                var formData = _this.getFormData($form);
                formData.id = id;

                $loader.css('display', 'inline-block');
                return ProcessConnection.updateProcessOption(formData)
                    .always(function () {
                        $loader.css('display', 'none');
                        _this.hideSaveBtn();
                    });
            };

            ProcessOptions.prototype.initDeliveryDate = function () {
                this.picker = new Pikaday({
                    disableWeekends: true,
                    firstDay: 1,
                    i18n: pikadayi18n,
                    onSelect: _this.updateDeliveryDate
                });
            };

            ProcessOptions.prototype.toggleDatepicker = function (e) {
                if ($(_this.picker.el).is(':visible')) return _this.picker.hide();
                e.stopPropagation();
                var minDateString = $(this).siblings('#process-delivery-date').data('mindate');

                _this.picker.setMinDate(new Date(+minDateString));
                $(this).next('.cart-process__pikaday-container').append(_this.picker.el);
                _this.picker.show();

                // Close picker on click outside.
                $(window).one('click.pikaday', function (e) {
                    if (!$.contains(_this.picker.el, e.target)) _this.picker.hide();
                });
            };

            ProcessOptions.prototype.updateDeliveryDate = function (date) {
                $(window).off('click.pikaday'); // remove outside close eventlistener
                _this.picker.hide();

                var $saveBtn = $('.process-general__form').find('.submit');
                $saveBtn.addClass('submit--visible');

                var dateField = $('.cart-process__delivery-date');
                $('#process-delivery-date').val(date.getTime());
                dateField.text(date.toLocaleDateString());
                if (!dateField.hasClass('cart-process__delivery-date--selected')) dateField.addClass('cart-process__delivery-date--selected');
            };

            ProcessOptions.prototype.fileValid = function (fileEl) {
                if (fileEl.data('required') && !fileEl.parent().next().text()) {
                    fileEl.parent().addClass('error');
                    return false;
                } else return true;
            };

            ProcessOptions.prototype.areaValid = function ($formEl) {
                var $a = $formEl.find('.height');
                var $b = $formEl.find('.width');

                var area = extractFloat($a) * extractFloat($b);
                area = Math.ceil(area * 100) / 100;
                var $area = $formEl.find('.area');

                var invalid = (area < $area.data('minsize') || area > $area.data('maxsize'));

                if (invalid) {
                    $area.val('').attr('placeholder', area);
                    $area.addClass('error');
                } else {
                    $area.val(area).removeClass('error');
                }

                return !invalid;
            };

            ProcessOptions.prototype.validateProcessOptions = function () {
                var isValid = true;

                // Has unsaved changes
                var $savebuttons = $('.submit--visible');
                if ($savebuttons.length > 0) {
                    isValid = false;
                    $savebuttons.addClass('error');
                }

                // Input fields with name attribute
                $('.process-option__form, .process-general__form').each(function (i, form) {
                    var requiredFields = _this.getFormData($(form), true);

                    Object.keys(requiredFields).forEach(function (field, j) {
                        if (requiredFields[field].trim() === "") {
                            isValid = false;
                            var $invalidField = $(form).find('[name=' + field + ']');
                            $invalidField.addClass('error');
                        }
                    });
                });

                // Design files
                $('.process-option__form .inputfile').each(function () {
                    if ($('.process-general__form [name="repeat"]').val() !== '') return; // Is repeat order

                    if (!_this.fileValid($(this))) isValid = false;
                });

                // Delivery note - not a required field?
                // isValid = fileValid($('.process-general__form .inputfile'));

                // Area fields
                $('.process-option__form .sizeInput').each(function () {
                    if (!_this.areaValid($(this))) isValid = false;
                });

                if (!isValid) {
                    $('html, body').animate({
                        scrollTop: $('.cart-process .error').first().closest('form').offset().top - 150
                    }, 250);
                }

                return isValid;
            };

            /**
             * Fetches form input (any input/select/checkbox/... field with a name attribute) from a html form and returns an object with key = name and value = value.
             * @param  {jQuery Element} formEl  - A form DOM element wrapped in jQuery.
             * @param {bool} onlyRequired       - If true, only fields with validation is fetched.
             * @return {Object}                 - An object with all inputs in the form. Empty inputs will still have a property with value undefined.
             */
            ProcessOptions.prototype.getFormData = function (formEl, onlyRequired) {
                var disabled = formEl.find(':input:disabled').removeAttr('disabled');
                var serialized = formEl.serializeArray();
                disabled.attr('disabled', 'disabled');

                return serialized.reduce(function (obj, inputObj) {
                    if (onlyRequired) {
                        if (formEl.find('[name=' + inputObj.name + ']').data('required')) {
                            obj[inputObj.name] = inputObj.value;
                        }
                    } else obj[inputObj.name] = inputObj.value;

                    return obj;
                }, {});
            };

            ProcessOptions.prototype.updateGeneralParameters = function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $loader = $(this).closest('.cart-process').find('.process-loader');
                var formData = _this.getFormData($(this));

                $loader.css('display', 'inline-block');
                ProcessConnection.updateGeneralParameters(formData)
                    .then(function () {
                        _this.getProcessOptionsPartialView();
                        $loader.css('display', 'none');
                        _this.hideSaveBtn();
                    })
                    .always(function () {
                        $loader.css('display', 'none');
                        _this.hideSaveBtn();
                    });
            };

            ProcessOptions.prototype.removeProcessOption = function () {
                var id = $(this).closest('.cart-process').data('process-id');

                ProcessConnection.removeProcessOption(id)
                    .then(function () {
                        _this.getProcessOptionsPartialView();
                    })
                    .always(function () {
                        // ...
                    });
            };

            ProcessOptions.prototype.getProcessOptionsPartialView = function () {
                ProcessConnection.getProcessOptions()
                    .then(function (res) {
                        _this.container.html(res);
                    })
                    .always(function () {
                        // ...
                    });
            };

            ProcessOptions.prototype.showSaveBtn = function () {
                var $saveBtn = $(this).closest('.cart-process__item').find('.submit');
                $saveBtn.addClass('submit--visible');
            };

            ProcessOptions.prototype.hideSaveBtn = function () {
                var $saveBtn = $('.cart-process__item').find('.submit');
                $saveBtn.removeClass('submit--visible');
            };

            return ProcessOptions;
        })();

        function extractFloat($val) {
            return parseFloat($val.val() && $val.val().replace(',', '.') || '0');
        }
    }
);

